'use strict';

goog.provide("Ntry.Sprite");

goog.require("Ntry.STATIC");

Ntry.Sprite = function(sprite) {
    this.image = sprite.image;
    this.currentFrameKey = 0;
    this.currentFrame = 0;
    this.width = sprite.width;
    this.height = sprite.height;
    this.regX = sprite.regX ? sprite.regX : 0;
    this.regY = sprite.regY ? sprite.regY : 0;
    this.scaleX = 1;
    this.rotation = sprite.rotation ? sprite.rotation : 0;
    this.opacity = sprite.opacity ? sprite.opacity : 1;
}

Ntry.Sprite.prototype.type =
    Ntry.STATIC.SPRITE;
